module.exports = __webpack_public_path__ + "static/media/素炒米粉.fbc922dc.jpg";